 <template>
  <div class="end-page">
    <adv-title>the operator</adv-title>
    <i>Congratulations! you have completed the scenario, now let’s debrief.</i>
    <br />
    <br /><b>> </b
    ><a href="https://the-adv.com/debrief" target="_new">the-adv.com/debrief</a>
  </div>
</template>
  
<script>
import AdvTitle from "../components/AdvTitle.vue";
export default {
  components: { AdvTitle },
  name: "end-page",
};
</script>

<style lang="less">
.end-page {
  width: 768px;
  height: 768px;
  padding: 120px;
  background-color: #000000;
  background-image: url("../assets/images/grid-white-x2.png");
  color: #f1ece6;
  font-size: 30px;
  font-weight: 100;

  a {
    text-decoration: none;
    color: inherit;
  }
}
</style>
